import React, { PureComponent } from 'react';
// redux
import { connect } from 'react-redux';
import { compose } from 'redux';
import { openModal, closeModal } from '../../redux/reducers/modal';
// hoc
import withSizes from 'react-sizes';
// components
import { NavLink, Redirect, Route, Switch } from 'react-router-dom';
import Button from '../../components/Button/Button';
import Icon from '../../components/Icon/Icon';
import PageWrapper from '../../components/PageWrapper/PageWrapper';
import Preloader from '../../components/Preloader/Preloader';
import MyJournals from './components/MyJournals';
import JournalPrompts from './components/JournalPrompts';
import NoteViewer from './components/NoteViewer';
import FilterMyJournals from './components/FilterMyJournals';
import FilterPrompts from './components/FilterPrompts';
// utils
import get from 'lodash.get';
// styles
import Style from 'style-it';
import classnames from 'classnames/bind';
import styles from './Journal.mod.css';

const cn = classnames.bind(styles);

class Journal extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      isSticky: false
    };
    this.noteViewerRef = React.createRef();
  }

  componentDidMount() {
    const { isDesktop } = this.props;
    if (isDesktop)
      this.viewerTop = this.noteViewerRef.current.getBoundingClientRect().top;
    window.addEventListener('scroll', this.handleStickOnScroll);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleStickOnScroll);
  }

  handleStickOnScroll = () => {
    if (this.props.isDesktop)
      this.setState({
        isSticky: this.viewerTop - 18 <= window.pageYOffset
      });
  };

  render() {
    const { openModal, isLoading, isDesktop, userColor } = this.props;
    const { isSticky } = this.state;

    return (
      <Style>
        {`
          .side-link:hover { color: ${userColor}; }
          .active { color: ${userColor}; }
        `}
        <PageWrapper>
          <div className={cn('wrapper', 'row')}>
            <h2>Journal</h2>
            <Preloader
              className={cn('preloader')}
              custom
              isActive={isLoading}
            />
            <div
              className={cn(
                'nav-wrapper',
                'col-lg-3 col-md-3 col-sm-12 col-xs-12'
              )}
            >
              <div className={cn('links')}>
                <NavLink
                  exact
                  to="/journal"
                  className={cn('link', 'side-link')}
                >
                  My Journals
                </NavLink>
                <NavLink
                  to="/journal/prompts"
                  className={cn('link', 'side-link')}
                >
                  Journal Prompts
                </NavLink>
              </div>
              <Button
                onClick={() =>
                  openModal('ADD_NEW_NOTE', {
                    userColor
                  })
                }
                className={cn('button')}
                color={userColor}
              >
                <Icon type="edit" className={cn('button-icon')} />
                New note
              </Button>
            </div>

            <div className="col-lg-9 col-md-9 col-sm-12 col-xs-12 column">
              <Switch>
                <Route
                  exact
                  path="/journal"
                  render={() => <FilterMyJournals userColor={userColor} />}
                />
                <Route
                  path="/journal/prompts"
                  render={() => <FilterPrompts userColor={userColor} />}
                />
              </Switch>
              <div className={cn('row')}>
                <div className="col-md-4 col-xs-12">
                  <Switch>
                    <Route
                      exact
                      path="/journal"
                      render={() => <MyJournals userColor={userColor} />}
                    />
                    <Route
                      path="/journal/prompts"
                      render={() => <JournalPrompts userColor={userColor} />}
                    />
                    <Redirect to="/404" />
                  </Switch>
                </div>
                {isDesktop && (
                  <div
                    className={cn('note-viewer-wrapper', 'col-md-8 col-xs-12')}
                  >
                    <NoteViewer
                      noteViewerRef={this.noteViewerRef}
                      className={cn('note-viewer', { sticky: isSticky })}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        </PageWrapper>
      </Style>
    );
  }
}

const mapSizesToProps = ({ width }) => ({
  isTablet: width <= 1024,
  isDesktop: width > 1024
});

const enhance = compose(
  connect(
    state => ({
      activeNote: state.journals.activeNote,
      myJournals: state.journals.myJournals,
      isLoading: state.journals.isLoading,
      userColor: get(state.auth, 'user.profile_color') || '#33C370'
    }),
    { openModal, closeModal }
  ),
  withSizes(mapSizesToProps)
);

export default enhance(Journal);



// WEBPACK FOOTER //
// ./src/containers/Journal/Journal.jsx